import { Button, Text } from '#atoms';
import { useSearchMemberQuery } from '#hooks/queries/member/useSearchMemberQuery';
import { Modal } from '#molecules';
import { DashboardChartSelectPage } from '#pages';
import { IGetCustomerDetailProps } from '#types/confirmationForms';
import { IExerciseRecord } from '#types/records';
import React, { useState } from 'react';
import Item from './Item';
import {
  ButtonContainer,
  Container,
  LectureBox,
  SearchBarStyle
} from './styles';

interface Props {
  isPreview?: boolean;
  onDetailClick?: ({ personId, id }: IGetCustomerDetailProps) => void;
}

export const CoachCustomerList = ({ isPreview, onDetailClick }: Props) => {
  const [name, setName] = useState<string>('');

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const { data } = useSearchMemberQuery({
    name
  });

  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [pageOpen, setPageOpen] = useState<boolean>(false);
  const [onNextCallback] = useState<() => void | undefined>();
  const [onLoadCallback] =
    useState<(selectedRecords: IExerciseRecord[]) => void | undefined>();

  const handleChartLoadButtonClick = () => {
    setModalOpen(false);
    setPageOpen(true);
  };

  const handleClickItem = (personId: string, id: string) => {
    if (!isPreview && onDetailClick) {
      onDetailClick({
        personId: personId,
        id: id
      });
    }
  };

  return (
    <>
      <Container>
        <SearchBarStyle
          onChange={onChange}
          placeholder="회원을 검색해주세요."
        />

        <div>
          <LectureBox
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '5px'
            }}
          >
            <div className="flex gap-4 items-center">
              <div className="text-[#938f9e] text-sm font-normal font-['Pretendard Variable'] leading-tight">
                총{' '}
              </div>
              <div className="text-[#bcb8c3] text-sm font-semibold font-['Pretendard Variable'] leading-tight">
                {data ? data.length : 0}명
              </div>
            </div>
          </LectureBox>
        </div>
        <div>
          {data?.map(person => {
            return (
              <div
                key={person.personId}
                onClick={() => handleClickItem(person.personId, '')}
              >
                <Item person={person} />
              </div>
            );
          })}
        </div>
        {modalOpen && (
          <Modal onClose={() => setModalOpen(false)}>
            <Text textStyle="t3">기존 운동차트에서 불러 오시겠습니까?</Text>
            <ButtonContainer>
              <Button background="anti" onClick={onNextCallback}>
                새로 작성하기
              </Button>
              <Button onClick={handleChartLoadButtonClick}>불러오기</Button>
            </ButtonContainer>
          </Modal>
        )}
        {pageOpen && (
          <DashboardChartSelectPage
            onPrevCallback={() => setPageOpen(false)}
            onLoadCallback={selectedRecords =>
              onLoadCallback && onLoadCallback(selectedRecords)
            }
          />
        )}
      </Container>
    </>
  );
};
